module.exports = __webpack_public_path__ + "img/user-illustarator-1.b6af845c.png";